module.exports = __webpack_public_path__ + "img/logo.353da9d0.png";